import React, { useEffect, useState } from 'react'
import { Box, Button, Card, Typography, Icon, Grow } from '@mui/material'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import AdxSwitch from 'components/reusable/switch/AdxSwitch'
import AdxInput from 'components/custom/AdxInput'
import AdxToolTip from 'components/custom/AdxToolTip'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import FloatActBtn from './floatActBtn'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'

const QuestionCard = ({
  handleDuplicate,
  handleQuesDelete,
  handleQues,
  handleFloatAddQuestion,
  handleFloatAddSection,
  valueType,
  valueRequired,
  valueQuestion,
  valueOption,
  valueDrag,
  quesKey,
  sectIndex,
  quesIndex,
  activeId,
  sx,
  sxCard,
  sxInput,
  is360,

  handleDrag,
  isDragging,
  ...rest
}) => {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('sm'))
  const matchesXsUp = useMediaQuery(theme.breakpoints.up('xs'))
  const matchesXsDown = useMediaQuery(theme.breakpoints.down('xs'))
  const matchesMd = useMediaQuery(theme.breakpoints.down('md'))
  const matchesMdUp = useMediaQuery(theme.breakpoints.up('md'))

  const [switchState, setSwitchState] = useState(true)
  const [optionState, setOptionState] = useState(valueOption)
  const [quesState, setQuesState] = useState(valueQuestion)

  useEffect(() => {
    setOptionState(valueOption)
  }, [valueType])

  useEffect(() => {
    if (optionState !== valueOption) {
      const optionDelay = setTimeout(() => {
        handleQues(quesKey, 'option', optionState)
      }, 250)
      return () => clearTimeout(optionDelay)
    }
  }, [optionState])
  // sets delay of 500ms since the last time the state is modified before calling the handler from index
  // did this to improve performance of component, not sure if there are better ways

  useEffect(() => {
    if (quesState !== valueQuestion) {
      const quesDelay = setTimeout(() => {
        handleQues(quesKey, 'question', quesState)
      }, 250)
      return () => clearTimeout(quesDelay)
    }
  }, [quesState])
  // sets delay of 500ms since the last time the state is modified before calling the handler from index
  // did this to improve performance of component, not sure if there are better ways

  const handleAddOption = () => {
    let items = Array.from(optionState)
    items.push('')
    setOptionState(items)
    handleQues(quesKey, 'option', optionState)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleAddOption()
    }
  }

  const handleInputOption = (i, index) => {
    let items = Array.from(optionState)
    items.splice(index, 1, i.target.value)
    setOptionState(items)
  }

  const handleRemoveOption = (index) => {
    let items = Array.from(optionState)
    items.splice(index, 1)
    setOptionState(items)
    handleQues(quesKey, 'option', optionState)
  }
  // in-component handling of question options

  const renderOptions = (type) => {
    return (
      <Box>
        {optionState.map((i, index) => (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              marginBottom: '10px',
            }}
            key={index}
          >
            <Icon
              sx={{
                marginX: '16px',
                marginTop: '16px',
                color: 'light-gray-text.main',
              }}
              disabled
            >
              {type === 'checkbox' ? 'check_box_outline_blank_icon' : 'radio_button_unchecked_icon'}
            </Icon>
            <AdxInput
              autoFocus={true}
              onKeyDown={handleKeyDown}
              onChange={(i) => handleInputOption(i, index)}
              value={i}
              size="standard"
              placeholder="Option"
              sxInput={{ padding: 2 }}
              isErrorShown={i === '' ? true : false}
              errorMessage={<AdxErrorMessage>Answer option cannot be empty</AdxErrorMessage>}
            />
            {optionState.length !== 1 ? (
              <Icon
                onClick={() => handleRemoveOption(index)}
                sx={{
                  color: 'error.main',
                  marginLeft: '10px',
                  marginRight: '4px',
                  marginTop: '16px',
                  '&:hover': {
                    cursor: 'pointer',
                  },
                }}
              >
                clear_icon
              </Icon>
            ) : null}
          </Box>
        ))}
        <Button
          variant="text"
          onClick={() => handleAddOption()}
          fullWidth
          disableFocusRipple
          sx={{
            py: 1,
            px: 2,
            color: 'alternate.main',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            '&:hover': {
              cursor: 'pointer',
              backgroundColor: 'alternate.light',
            },
            marginLeft: '35px',
            width: '50%',
          }}
        >
          <Icon color="alternate" sx={{ mr: 1.5 }}>
            add_icon
          </Icon>
          <Typography variant="body1">Add option</Typography>
        </Button>
      </Box>
    )
  }
  {
    /*===================================================================================*/
  }
  {
    /* Question variant starts here */
  }
  {
    /*===================================================================================*/
  }
  const renderQuestion = () => {
    switch (valueType) {
      case '1':
        return null
      case '2':
        return (
          <Box
            sx={{
              display: 'flex',
              ...(matchesMd
                ? { flexDirection: 'column', gap: '20px' }
                : {
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                  }),
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
              }}
            >
              <AdxDropdown
                label={'Scale'}
                sx={{
                  minWidth: '80px',
                }}
                value={optionState[0] ?? 1}
                onChange={(i) => handleInputOption(i, 0)}
              >
                <AdxMenuItem value="0" selectedvalue={optionState[0]}>
                  <Typography variant="body1" align="center">
                    0
                  </Typography>
                </AdxMenuItem>
                <AdxMenuItem value="1" selectedvalue={optionState[0]}>
                  <Typography variant="body1" align="center">
                    1
                  </Typography>
                </AdxMenuItem>
              </AdxDropdown>

              <Typography
                variant="body1"
                sx={{
                  marginTop: '42px',
                  marginLeft: '16px',
                  marginRight: '16px',
                }}
              >
                to
              </Typography>

              <AdxDropdown
                label={'⠀'}
                sx={{
                  minWidth: '80px',
                }}
                value={optionState[1] ?? 5}
                onChange={(i) => handleInputOption(i, 1)}
              >
                <AdxMenuItem value="5" selectedvalue={optionState[1]}>
                  <Typography variant="body1" align="center">
                    5
                  </Typography>
                </AdxMenuItem>
                <AdxMenuItem value="10" selectedvalue={optionState[1]}>
                  <Typography variant="body1" align="center">
                    10
                  </Typography>
                </AdxMenuItem>
              </AdxDropdown>
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                width: '68%',
                // paddingTop:"26px"
              }}
            >
              <AdxInput
                label={'Scale label (Optional)'}
                size="standard"
                placeholder="Option"
                sxLabel={{ whiteSpace: 'pre' }}
                sx={{ minWidth: '160px' }}
                onChange={(i) => handleInputOption(i, 2)}
                value={optionState[2] ?? ''}
              />
              <Typography
                variant="body1"
                sx={{
                  marginTop: '42px',
                  marginLeft: '16px',
                  marginRight: '16px',
                }}
              >
                to
              </Typography>
              <AdxInput
                label={'⠀'}
                size="standard"
                placeholder="Option"
                sx={{ minWidth: '160px' }}
                onChange={(i) => handleInputOption(i, 3)}
                value={optionState[3] ?? ''}
              />
            </Box>
          </Box>
        )
      case '3':
        return renderOptions('')
      case '4':
        return renderOptions('checkbox')
      default:
        break
    }
  }
  {
    /*===================================================================================*/
  }
  {
    /* Component starts here */
  }
  {
    /*===================================================================================*/
  }
  return (
    <Box display="flex" flexDirection="row" alignItems="flex-end" position="relative">
      <Card
        sx={{
          width: '100%',
          height: '100px',
          paddingTop: '16px',
          paddingBottom: '20px',
          paddingRight: '16px',
          boxShadow: '0px 0px 10px lightgray',
          borderRadius: '10px',
          display: 'flex',
          flexDirection: 'row',
          ...sxCard,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            '&:hover': {
              cursor: 'move',
            },
          }}
          {...handleDrag}
        >
          <Icon
            sx={{
              color: 'light-gray-text-2.main',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            drag_indicator_icon
          </Icon>
          <Grow in={activeId === quesKey}>
            <Box
              sx={{
                backgroundColor: 'alternate.main',
                width: '7px',
                height: '100%',
                borderRadius: '3.5px',
                marginRight: '29px',
              }}
            />
          </Grow>
        </Box>
        <Box
          sx={{
            width: '100%',
          }}
          display="flex"
          flexDirection="column"
          gap={1}
        >
          {/*===================================================================================*/}
          {/* Question type selection starts here */}
          {/*===================================================================================*/}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              marginBottom: '10px',
            }}
          >
            {is360 ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  minWidth: '250px',
                  marginRight: '34px',
                }}
              >
                <Icon sx={{ color: 'light-gray-text.main', marginRight: '14px' }}>
                  linear_scale_icon
                </Icon>
                <Typography
                  sx={{
                    marginRight: '20px',
                  }}
                >
                  Linear Scale
                </Typography>
              </Box>
            ) : (
              <AdxDropdown
                sx={{
                  minWidth: '250px',
                  marginRight: '34px',
                }}
                value={valueType}
                onChange={(i) => handleQues(quesKey, 'quesType', i.target.value)}
              >
                <AdxMenuItem value="1" selectedvalue={valueType}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Icon sx={{ color: 'light-gray-text.main', marginRight: '14px' }}>
                      segment_icon
                    </Icon>
                    <Typography
                      variant="body1"
                      sx={{
                        marginRight: '20px',
                      }}
                    >
                      Paragraph
                    </Typography>
                  </Box>
                </AdxMenuItem>
                <AdxMenuItem value="3" selectedvalue={valueType}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Icon sx={{ color: 'light-gray-text.main', marginRight: '14px' }}>
                      radio_button_checked_icon
                    </Icon>
                    <Typography
                      sx={{
                        marginRight: '20px',
                      }}
                    >
                      Multiple Choices
                    </Typography>
                  </Box>
                </AdxMenuItem>
                <AdxMenuItem value="4" selectedvalue={valueType}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Icon sx={{ color: 'light-gray-text.main', marginRight: '14px' }}>
                      check_box_icon
                    </Icon>
                    <Typography
                      sx={{
                        marginRight: '20px',
                      }}
                    >
                      Checkboxes
                    </Typography>
                  </Box>
                </AdxMenuItem>
                <AdxMenuItem value="2" selectedvalue={valueType}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Icon sx={{ color: 'light-gray-text.main', marginRight: '14px' }}>
                      linear_scale_icon
                    </Icon>
                    <Typography
                      sx={{
                        marginRight: '20px',
                      }}
                    >
                      Linear Scale
                    </Typography>
                  </Box>
                </AdxMenuItem>
              </AdxDropdown>
            )}
            {matches ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <AdxSwitch
                    state={valueRequired}
                    onChange={() => {
                      setSwitchState(!switchState)
                      handleQues(quesKey, 'quesRequired', !valueRequired)
                    }}
                  />
                  <Typography
                    sx={{
                      color: 'light-gray-text.main',
                    }}
                  >
                    Required
                  </Typography>
                </Box>
                <Box sx={{ minWidth: '65px' }}>
                  <AdxToolTip title="Duplicate">
                    <Icon
                      onClick={() => handleDuplicate(sectIndex, quesIndex, quesKey)}
                      sx={{
                        color: 'alternate.main',
                        marginX: '4px',
                        '&:hover': {
                          cursor: 'pointer',
                        },
                      }}
                    >
                      content_copy_icon
                    </Icon>
                  </AdxToolTip>
                  <AdxToolTip title="Delete">
                    <Icon
                      onClick={() => handleQuesDelete(sectIndex, quesIndex, quesKey)}
                      sx={{
                        color: 'error.main',
                        marginX: '4px',
                        '&:hover': {
                          cursor: 'pointer',
                        },
                      }}
                    >
                      remove_circle_icon
                    </Icon>
                  </AdxToolTip>
                </Box>
              </Box>
            ) : null}
          </Box>
          {/*===================================================================================*/}
          {/* Question starts here */}
          {/*===================================================================================*/}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <AdxInput
              label="Question"
              value={quesState}
              sxLabel={{
                color: 'black' /*, fontSize: "30px!important" */,
              }}
              sxSubLabel={{ color: 'red' }}
              size="standard"
              placeholder="Type here"
              onChange={(i) => setQuesState(i.target.value)}
              multiline
              sxInput={{ padding: 2 }}
              maxRows={isDragging ? 1 : null}
              isErrorShown={quesState === '' ? true : false}
              errorMessage={
                <AdxErrorMessage>
                  Question cannot be empty<span style={{ color: 'red' }}> * </span>
                </AdxErrorMessage>
              }
            />
          </Box>
          {isDragging
            ? null
            : // renderQuestion()
            activeId === quesKey
            ? renderQuestion()
            : null}
          {matches ? null : (
            <Box
              sx={{
                borderTop: '1px solid',
                borderTopColor: 'gray-line.main',
                paddingTop: '16px',
              }}
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  width: '100%',
                }}
                gap={1}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    borderRight: '1px solid',
                    borderRightColor: 'gray-line.main',
                    paddingRight: '16px',
                  }}
                >
                  <AdxSwitch
                    state={valueRequired}
                    onChange={() => {
                      setSwitchState(!switchState)
                      handleQues(quesKey, 'quesRequired', !valueRequired)
                    }}
                  />
                  <Typography
                    sx={{
                      color: 'light-gray-text.main',
                    }}
                  >
                    Required
                  </Typography>
                </Box>
                <Box sx={{ minWidth: '65px' }}>
                  <AdxToolTip title="Duplicate">
                    <Icon
                      onClick={() => handleDuplicate(sectIndex, quesIndex, quesKey)}
                      sx={{
                        color: 'alternate.main',
                        marginX: '8px',
                        '&:hover': {
                          cursor: 'pointer',
                        },
                      }}
                    >
                      content_copy_icon
                    </Icon>
                  </AdxToolTip>
                  <AdxToolTip title="Delete">
                    <Icon
                      onClick={() => handleQuesDelete(sectIndex, quesIndex, quesKey)}
                      sx={{
                        color: 'error.main',
                        marginX: '4px',
                        '&:hover': {
                          cursor: 'pointer',
                        },
                      }}
                    >
                      remove_circle_icon
                    </Icon>
                  </AdxToolTip>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Card>
      {matchesMdUp ? (
        <FloatActBtn
          handleFloatAddQuestion={handleFloatAddQuestion}
          handleFloatAddSection={handleFloatAddSection}
          sectIndex={sectIndex}
          quesIndex={quesIndex}
        />
      ) : null}
    </Box>
  )
}

export default QuestionCard
